module.exports = __webpack_public_path__ + "img/ctrl-swap-root-stub-+i.af080148.svg";